import { Box, styled, Typography } from '@mui/material';

export const StyledFirstTimeLessonCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '56px',
  alignSelf: 'stretch',
  marginBottom: '48px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '25px',
  },
}));

export const StyledFirstTimeLessonImage = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: '1',
  display: 'block',
  margin: '0px -20px -20px 15px', // tweak to offset over the background
  [theme.breakpoints.down('sm')]: {
    margin: '10px 0px -10px 0px',
    width: '180px',
    height: 'auto',
  },
}));

export const BackgroundImageFrame = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette?.primary.main,
  position: 'relative',
  padding: '20px',
  width: '400px',
  height: '330px',
  [theme.breakpoints.down('sm')]: {
    width: '200px',
    height: '165px',
    padding: '10px',
    marginTop: '10px',
  },
}));

export const StyledRightSideContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  flex: '1 0 0,',
}));

export const StyledPricingContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'baseline',
}));

export const StyledPricingText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Womby, sans-serif',
  color: theme.palette?.primary.main,
}));
